var _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect, _rect2, _path35, _path36, _path37, _path38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindjobs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 830,
    height: 618.45,
    viewBox: "0 0 830 618.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -55)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 830,
    height: 0.415,
    transform: "translate(0 543.484)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.979,
    height: 0.415,
    transform: "translate(691.855 570.193)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.425,
    height: 0.415,
    transform: "translate(535.4 574.709)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.855,
    height: 0.415,
    transform: "translate(658.339 554.789)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71.695,
    height: 0.415,
    transform: "translate(87.084 557.577)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.508,
    height: 0.415,
    transform: "translate(173.57 557.577)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 155.509,
    height: 0.415,
    transform: "translate(218.24 564.583)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.2,524.448H47.672a9.479,9.479,0,0,1-9.462-9.479V64.4A9.479,9.479,0,0,1,47.672,55H368.2a9.479,9.479,0,0,1,9.479,9.479V514.969A9.479,9.479,0,0,1,368.2,524.448ZM47.672,55.332A9.064,9.064,0,0,0,38.625,64.4V514.969a9.064,9.064,0,0,0,9.047,9.064H368.2a9.08,9.08,0,0,0,9.064-9.064V64.4a9.08,9.08,0,0,0-9.064-9.064Z",
    transform: "translate(25.219 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.525,524.448H263.979a9.5,9.5,0,0,1-9.479-9.479V64.4a9.5,9.5,0,0,1,9.479-9.4H584.525a9.479,9.479,0,0,1,9.446,9.4V514.969A9.479,9.479,0,0,1,584.525,524.448ZM263.979,55.332a9.08,9.08,0,0,0-9.064,9.064V514.969a9.08,9.08,0,0,0,9.064,9.064H584.525a9.08,9.08,0,0,0,9.064-9.064V64.4a9.08,9.08,0,0,0-9.064-9.064Z",
    transform: "translate(167.97 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 118.275,
    height: 401.239,
    transform: "translate(160.273 80.294)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.337,103.37h-6.906L128.18,504.609h6.906Z",
    transform: "translate(84.599 -23.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.947,
    height: 3.536,
    transform: "translate(159.509 81.855)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.947,
    height: 7.57,
    transform: "translate(159.509 478.03)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 110.506,
    height: 0.332,
    transform: "translate(164.008 485.268)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.433,106.283H211.94V509.7h6.623V101.32H94.81V509.7h6.623Z",
    transform: "translate(62.575 -24.429)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 118.275,
    height: 401.239,
    transform: "translate(291.894 80.294)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.71,103.37h-37.7L179.76,504.609h37.7Z",
    transform: "translate(118.642 -23.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120.267,
    height: 3.536,
    transform: "translate(291.131 81.855)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120.267,
    height: 7.57,
    transform: "translate(291.131 478.03)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 110.506,
    height: 0.332,
    transform: "translate(295.629 485.268)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.723,106.283H291.23V509.7h6.607V101.32H174.1V509.7h6.623Z",
    transform: "translate(114.906 -24.429)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.955,
    height: 401.239,
    transform: "translate(423.499 80.294)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.507,103.37H306.6L265.35,504.609h6.906Z",
    transform: "translate(175.131 -23.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.947,
    height: 3.536,
    transform: "translate(422.752 81.855)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.947,
    height: 7.57,
    transform: "translate(422.752 478.03)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 110.506,
    height: 0.332,
    transform: "translate(427.251 485.268)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.013,106.283H370.5V509.7h6.623V101.32H253.39V509.7h6.623Z",
    transform: "translate(167.237 -24.429)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 118.275,
    height: 401.239,
    transform: "translate(555.121 80.294)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.086,103.37h-37.7L351.12,504.609h37.715Z",
    transform: "translate(231.739 -23.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.947,
    height: 3.536,
    transform: "translate(554.357 81.855)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.947,
    height: 7.57,
    transform: "translate(554.357 478.03)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.287,106.283H449.793V509.7h6.623V101.32H332.68V509.7h6.607Z",
    transform: "translate(219.569 -24.429)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 110.506,
    height: 0.332,
    transform: "translate(558.856 485.268)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.344,
    height: 88.793,
    transform: "translate(190.601 389.22)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.383,281.99v22.277H120.76V281.99Z",
    transform: "translate(79.702 94.813)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(238.658 399.081) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(225.943 399.081) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(213.21 399.081) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(200.478 399.081) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(238.658 411.033) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(225.943 411.033) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(213.21 411.033) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(200.478 411.033) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(238.658 422.968) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(225.943 422.968) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(213.21 422.968) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(225.943 388.755) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(213.21 388.755) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(200.478 422.968) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(238.658 434.903) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(225.943 434.903) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(213.21 434.903) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(200.478 434.903) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(238.658 446.855) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(225.943 446.855) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(213.21 446.855) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(200.478 446.855) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(238.658 458.791) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(225.943 458.791) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(213.21 458.791) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(200.478 458.791) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(238.658 470.759) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(225.943 470.759) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(213.21 470.759) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(200.478 470.759) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.344,
    height: 88.793,
    transform: "translate(480.089 389.22)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.79,281.99v22.277H295.15V281.99Z",
    transform: "translate(194.799 94.813)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(528.146 399.081) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(515.413 399.081) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(502.698 399.081) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(489.966 399.081) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(528.146 411.033) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(515.413 411.033) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(502.698 411.033) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(489.966 411.033) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(528.146 422.968) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(515.413 422.968) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(502.698 422.968) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(515.413 388.755) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(502.698 388.755) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(489.966 422.968) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(528.146 434.903) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(515.413 434.903) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(502.698 434.903) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(489.966 434.903) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(528.146 446.855) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(515.413 446.855) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(502.698 446.855) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(489.966 446.855) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(528.146 458.791) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(515.413 458.791) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(502.698 458.791) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(489.966 458.791) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(528.146 470.759) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(515.413 470.759) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(502.698 470.759) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.574,
    height: 6.574,
    transform: "translate(489.966 470.759) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.999,
    height: 56.44,
    transform: "translate(567.006 421.557)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.98,312.72h16.583v5.893H343.98Z",
    transform: "translate(227.027 115.095)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.98,319.6h16.583v5.876H343.98Z",
    transform: "translate(227.027 119.636)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.98,326.47h16.583v5.876H343.98Z",
    transform: "translate(227.027 124.17)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.98,333.34h16.583v5.893H343.98Z",
    transform: "translate(227.027 128.704)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.87,312.72h16.583v5.893H356.87Z",
    transform: "translate(235.534 115.095)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.87,319.6h16.583v5.876H356.87Z",
    transform: "translate(235.534 119.636)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.87,326.47h16.583v5.876H356.87Z",
    transform: "translate(235.534 124.17)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.87,333.34h16.583v5.893H356.87Z",
    transform: "translate(235.534 128.704)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.799,
    height: 35.076,
    transform: "translate(351.837 442.938)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(390.947 452.665) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(380.572 452.665) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(370.23 452.665) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(359.855 452.665) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(390.947 462.376) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(380.572 462.376) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(370.23 462.376) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(359.855 462.376) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(390.947 472.087) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(380.572 472.087) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(370.23 472.087) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(359.855 472.087) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.799,
    height: 35.076,
    transform: "translate(433.907 442.938)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(473.034 452.665) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(462.659 452.665) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(452.284 452.665) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(441.942 452.665) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(473.034 462.376) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(462.659 462.376) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(452.284 462.376) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(441.942 462.376) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(473.034 472.087) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(462.659 472.087) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(452.284 472.087) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.345,
    height: 5.345,
    transform: "translate(441.942 472.087) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.799,
    height: 61.005,
    transform: "translate(304.378 416.992)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(327.784 419.681)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(307.05 419.681)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(327.784 439.12)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(307.05 439.12)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(327.784 458.558)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(307.05 458.558)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.799,
    height: 61.005,
    transform: "translate(619.993 416.992)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(643.399 419.681)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(622.666 419.681)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(643.399 439.12)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(622.666 439.12)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(643.399 458.558)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.72,
    height: 15.073,
    transform: "translate(622.666 458.558)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.365,407.156s-8.4-18.26,1.2-36.42,12.4-22.327,6.275-26.045S96.9,359.165,96.9,359.165a40.8,40.8,0,0,1-.847-25.581c4.25-13.081,6.922-34.379,1.112-36.669s-1.112,26.56-6.175,36.42a84.926,84.926,0,0,1-4.98-21.464c-.7-10.508.4-27.29-4.2-31.54S74.279,279,78.794,302.194a242.656,242.656,0,0,1,4.482,42.031s-9.96-30.411-16.6-31.308-6.64,8.964-.946,17.513,16.783,23.854,18.592,31.723c0,0-10.956-22.891-20.8-15.87S72.1,367.117,80.3,372.113s13.911,36.3,13.911,36.3Z",
    transform: "translate(40.062 92.637)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.944,411.844s8.184-18.459-1.66-36.387-12.666-22.161-6.64-25.946,9.1,14.326,9.1,14.326,4.98-12.583.6-25.6-7.354-34.279-1.56-36.653,1.428,26.56,6.64,36.321a84.876,84.876,0,0,0,4.7-21.58c.564-10.508-.73-27.274,3.818-31.64s7.52-1.444,3.32,21.812a243.752,243.752,0,0,0-4.017,42.147s9.611-30.561,16.3-31.54,6.789,8.848,1.162,17.48-16.5,24.1-18.26,32c0,0,10.674-23.057,20.6-16.185s-8.3,20.966-16.467,26.079-13.479,36.52-13.479,36.52Z",
    transform: "translate(47.843 95.469)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.028,352.69H61.4l5.478,48.372H123.55Z",
    transform: "translate(40.524 141.475)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.591,373.781c.249-1.66,5.843-40.321-5.378-53.684a12.151,12.151,0,0,0-9.329-4.582c-22.676-.531-25.78,17.679-25.813,17.862l2.689.415c.1-.664,2.789-16.069,23.057-15.571a9.4,9.4,0,0,1,7.321,3.619c10.458,12.433,4.831,51.161,4.781,51.543Z",
    transform: "translate(252.826 116.932)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.306,368.507l2.706-.083c0-.365-.9-35.657,16.5-42.944,17.032-7.138,24.7,7.536,25.016,8.167l2.424-1.212c-.1-.166-9.08-17.579-28.486-9.445C407.36,331.074,408.273,366.98,408.306,368.507Z",
    transform: "translate(269.472 120.446)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.336,385.138c0-.564.166-56.44,11.039-72.708,10.441-15.67,27.307-8.3,28.021-7.968l1.112-2.457c-.2-.1-19.638-8.682-31.391,8.931-11.321,17-11.487,71.861-11.487,74.2Z",
    transform: "translate(268.376 106.587)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.955,319.5s9.96,3.652,6.955,12.267-34.246,22.792-34.246,22.792-13.1-12-1.062-31.54S409.69,313.339,409.955,319.5Z",
    transform: "translate(248.5 114.277)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,310.531s-7.038-.747-6.474-4.98,27.324-15.305,43.16,2.523c0,0-10.109,17.364-24.717,17.579S417.8,310.531,417.8,310.531Z",
    transform: "translate(271.452 105.548)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.862,325.464s-4.847-3.918.382-5.827,30.926-1.361,31.191,24.07c0,0-29.88,4.98-33.615-4.714S420.862,325.464,420.862,325.464Z",
    transform: "translate(275.591 119.217)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.453,402.033h46.43l5-50.813H390.44Z",
    transform: "translate(257.69 140.505)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.403,
    height: 11.222,
    transform: "translate(707.044 497.319) rotate(180)",
    fill: "#e0e0e0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.143 635.867)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 321.857,
    cy: 18.791,
    rx: 321.857,
    ry: 18.791,
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(535.483 199.705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.134,422.085l12.4,1.394-1.544-36.62L396.2,388.952Z",
    transform: "translate(-273.991 19.322)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.57,421.606l12.5-1.245,3.187-32.121h-14.94Z",
    transform: "translate(-298.167 20.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.134,422.085l12.4,1.394-1.544-36.62L396.2,388.952Z",
    transform: "translate(-273.991 19.322)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.57,421.606l12.5-1.245,3.187-32.121h-14.94Z",
    transform: "translate(-298.167 20.233)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.586,247.562s-1.262,8.3-1.926,8.3-8.3-7.337-8.3-7.337l5.129-7.1Z",
    transform: "translate(-277.845 -76.668)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.586,247.562s-1.262,8.3-1.926,8.3-8.3-7.337-8.3-7.337l5.129-7.1Z",
    transform: "translate(-277.845 -76.668)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.094,185.72c7.52,1.66,29.515,50.746,31.54,58.532s-17.081,43.691-17.081,43.691l-9.18-10.143,10.558-33.515L387.5,213.425Z",
    transform: "translate(-279.733 -113.43)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.094,185.72c7.52,1.66,29.515,50.746,31.54,58.532s-17.081,43.691-17.081,43.691l-9.18-10.143,10.558-33.515L387.5,213.425Z",
    transform: "translate(-279.733 -113.43)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.849,407H399.478a1.112,1.112,0,0,0-1.079.863l-2.59,11.172a1.809,1.809,0,0,0,1.826,2.224c4.98-.083,8.516-.365,14.724-.365,3.835,0,15.338.4,20.617.4s6.009-5.212,3.868-5.694c-9.661-2.108-16.932-4.98-20-7.819A3.071,3.071,0,0,0,414.849,407Z",
    transform: "translate(-274.281 32.615)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.24,251.648s4.565,23.788,10.275,52.39c3.32,16.484,6.972,34.545,10.358,50.613,1.228,5.777,2.407,11.288,3.536,16.384,8.632,39.176,24.336,142.926,24.336,142.926l19.472-3.22s-3.868-112.764-10.043-152.72c-5.627-36.52-17.015-120.931-17.015-120.931Z",
    transform: "translate(-293.104 -79.526)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.43,283.083c3.32,16.484,6.972,34.545,10.358,50.613a127.106,127.106,0,0,0-4.98-64.856A100.85,100.85,0,0,0,373.43,283.083Z",
    transform: "translate(-289.019 -58.571)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.816,407H360.478a1.112,1.112,0,0,0-1.079.863l-2.59,11.172a1.809,1.809,0,0,0,1.809,2.224c4.98-.083,8.532-.365,14.741-.365,3.818,0,15.338.4,20.617.4s6.009-5.212,3.851-5.694c-9.661-2.108-16.932-4.98-20-7.819a3.021,3.021,0,0,0-2.009-.78Z",
    transform: "translate(-300.021 32.615)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.374,238.12s-.564,85.258-.1,122.126c.515,40.371-11.72,152.72-11.72,152.72l-19.688-1.66s-.78-102.92-3.835-142.909c-3.42-44.72-6.042-121.827-6.042-121.827Z",
    transform: "translate(-303.169 -78.846)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.888,285.321c0-6.64-.83-17.181-1.1-26.361-.249-8.416-.747-17.729-1.66-27.473a281.909,281.909,0,0,0-7.022-41.5s7.951-2.075,16.965-3.42c1.76-.266,3.586-.5,5.378-.7a250.318,250.318,0,0,1,28.552-1.66c1.179,0,2.341.083,3.469.183a130.5,130.5,0,0,1,16,2.191s14.674,32.835,7.4,96.18Z",
    transform: "translate(-307.05 -114.427)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.888,285.321c0-6.64-.83-17.181-1.1-26.361-.249-8.416-.747-17.729-1.66-27.473a281.909,281.909,0,0,0-7.022-41.5s7.951-2.075,16.965-3.42c1.76-.266,3.586-.5,5.378-.7a250.318,250.318,0,0,1,28.552-1.66c1.179,0,2.341.083,3.469.183a130.5,130.5,0,0,1,16,2.191s14.674,32.835,7.4,96.18Z",
    transform: "translate(-307.05 -114.427)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,200.19c1.179,7.038,2.042,13.994,2.722,20.75.116,1.162.216,2.307.315,3.453a59.991,59.991,0,0,0,2.507-21.879,14.708,14.708,0,0,0-5.544-2.324Z",
    transform: "translate(-305.367 -103.88)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.868,165.81c2.224,9.08,4.814,25.8-1.328,32.27a28.336,28.336,0,0,0,22.41,7.52c7.9-.631,8.034-6.159,6.125-9.13-10.358-1.859-10.441-9.462-8.981-16.7Z",
    transform: "translate(-298.186 -126.571)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.868,165.81c2.224,9.08,4.814,25.8-1.328,32.27a28.336,28.336,0,0,0,22.41,7.52c7.9-.631,8.034-6.159,6.125-9.13-10.358-1.859-10.441-9.462-8.981-16.7Z",
    transform: "translate(-298.186 -126.571)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.895,169.24l10.79,8.3a30.347,30.347,0,0,0-.647,5.113c-3.934-.349-9.512-4.333-10.109-8.416a13.679,13.679,0,0,1-.033-5Z",
    transform: "translate(-294.793 -124.307)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.852,167.152c3.054,12.251,4.216,19.588,11.62,24.734,11.2,7.736,25.448-.93,26.112-13.894.6-11.62-4.5-29.747-17.546-32.3a17.413,17.413,0,0,0-20.186,21.464Z",
    transform: "translate(-299.669 -140.064)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.852,167.152c3.054,12.251,4.216,19.588,11.62,24.734,11.2,7.736,25.448-.93,26.112-13.894.6-11.62-4.5-29.747-17.546-32.3a17.413,17.413,0,0,0-20.186,21.464Z",
    transform: "translate(-299.669 -140.064)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.358,159.188a1.816,1.816,0,0,0,1.527,1.66c.647,0,1.046-1.062.863-2.058a1.834,1.834,0,0,0-1.527-1.66C369.573,157.13,369.175,158.176,369.358,159.188Z",
    transform: "translate(-291.736 -132.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.228,157.818a1.83,1.83,0,0,0,1.544,1.66c.664,0,1.046-1.046.847-2.058s-.863-1.66-1.527-1.66S376.046,156.839,376.228,157.818Z",
    transform: "translate(-287.202 -133.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.09,157.75a35.323,35.323,0,0,0,6.441,7.37,6.109,6.109,0,0,1-4.648,1.76Z",
    transform: "translate(-288.583 -131.89)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.882,167.283a7.636,7.636,0,0,0,1.328-.166.3.3,0,0,0,.249-.349.315.315,0,0,0-.349-.249,8.1,8.1,0,0,1-7.1-1.843.3.3,0,0,0-.432,0,.315.315,0,0,0,0,.432A8.3,8.3,0,0,0,374.882,167.283Z",
    transform: "translate(-292.28 -127.38)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.061,158.258a.614.614,0,0,0,.515-.332A4.831,4.831,0,0,1,371,155.2a.614.614,0,0,0,.531-.681.6.6,0,0,0-.664-.531,6.092,6.092,0,0,0-4.366,3.32.581.581,0,0,0,.266.8.648.648,0,0,0,.3.149Z",
    transform: "translate(-293.639 -134.374)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.727,155.46a.8.8,0,0,0,.332-.116.614.614,0,0,0,.116-.847,5.86,5.86,0,0,0-4.881-2.507.6.6,0,0,0-.564.631.581.581,0,0,0,.631.564,4.715,4.715,0,0,1,3.851,2.025.548.548,0,0,0,.515.249Z",
    transform: "translate(-287.501 -135.692)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.5,155.5s-3.9-1.76-4.98,1.179.465,9.96.465,9.96l-.946-1.112s-1.278,16.5-8.433,13.828-19.555-16.716-6.275-27.755c0,0,.83-4.084,10.292-7.885s22.559-.1,25.879,5.993S395.7,160,395.7,160a9.594,9.594,0,0,0-2.656-3.486A4.166,4.166,0,0,1,391.187,160a7.337,7.337,0,0,0-1.56-3.685,8.3,8.3,0,0,1-1.029,3.453c-2.042-6.54-6.856-7.005-8.3-6.64A2.49,2.49,0,0,0,378.5,155.5Z",
    transform: "translate(-302.858 -142.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.226,168.546a11.836,11.836,0,0,0,7.088,5.76c4.034,1.145,6.125-2.473,4.98-6.325-.963-3.453-4.233-8.217-8.3-7.686a5.445,5.445,0,0,0-3.768,8.25Z",
    transform: "translate(-300.915 -130.237)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.226,168.546a11.836,11.836,0,0,0,7.088,5.76c4.034,1.145,6.125-2.473,4.98-6.325-.963-3.453-4.233-8.217-8.3-7.686a5.445,5.445,0,0,0-3.768,8.25Z",
    transform: "translate(-300.915 -130.237)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.9,189.552l-1.544,5.91s6.823,37.068,8.068,56.573l-2.955,4.98-4.3-4.316s-1.062-50.331-2.822-57.121l-5.146-4.6,3.951-3.32Z",
    transform: "translate(-290.491 -112.15)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.025,191.528,362.581,181.02l-6.291,7.719,19.389,14.392,10.143-9.628,11.471,7.337-1.826-14.077-13.18-5.744Z",
    transform: "translate(-300.331 -116.532)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.025,191.528,362.581,181.02l-6.291,7.719,19.389,14.392,10.143-9.628,11.471,7.337-1.826-14.077-13.18-5.744Z",
    transform: "translate(-300.331 -116.532)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.009,248.6l-36.47,1.975-.3-4.349,36.42-1.494Z",
    transform: "translate(-295.084 -74.484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.41,245.68l.4,4.366-18.542,1.013-.166-4.631Z",
    transform: "translate(-303.097 -73.857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.49,244.815l8.964-.365.5,3.718-9.147.5Z",
    transform: "translate(-279.739 -74.668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.011,245.59l.332,3.519a.93.93,0,0,1-.88,1l-7.271.249a.9.9,0,0,1-.93-.847l-.282-3.469a.93.93,0,0,1,.88-1l7.2-.282A.929.929,0,0,1,383.011,245.59Z",
    transform: "translate(-288.657 -74.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.206,253.965l-3.171-8.3c-1.66-3.6-7.3-.266-7.3-.266a1.311,1.311,0,0,0-.681,1.428l4.266,15.953a2.241,2.241,0,0,0,3.851.847l1.56-1.66a7.852,7.852,0,0,0,1.477-8Z",
    transform: "translate(-277.407 -74.971)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.206,253.965l-3.171-8.3c-1.66-3.6-7.3-.266-7.3-.266a1.311,1.311,0,0,0-.681,1.428l4.266,15.953a2.241,2.241,0,0,0,3.851.847l1.56-1.66a7.852,7.852,0,0,0,1.477-8Z",
    transform: "translate(-277.407 -74.971)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.564,292.455h-.747a26.028,26.028,0,0,1-9.3-1.776c-2.722-1.162-4.2-2.756-4.15-4.5,0-3.4,5.959-5.827,13.712-5.677a25.948,25.948,0,0,1,9.3,1.776c2.722,1.162,4.2,2.756,4.167,4.5C361.462,290.064,355.951,292.455,348.564,292.455Zm-1.212-10.292c-6.64,0-11.288,2.092-11.321,4.05,0,1,1.145,2.092,3.154,2.938a23.72,23.72,0,0,0,8.682,1.66c7.005.133,11.969-2.025,12.018-4.05,0-1-1.162-2.092-3.154-2.938a23.721,23.721,0,0,0-8.682-1.66Z",
    transform: "translate(-314.799 -50.878)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.58,285.453l-.979,45.152a2.673,2.673,0,0,0,2.623,2.739l65.852,1.428a2.706,2.706,0,0,0,2.756-2.623l.979-45.135a2.706,2.706,0,0,0-2.639-2.756l-65.852-1.428a2.673,2.673,0,0,0-2.739,2.623Z",
    transform: "translate(-322.567 -49.338)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.58,285.453l-.979,45.152a2.673,2.673,0,0,0,2.623,2.739l65.852,1.428a2.706,2.706,0,0,0,2.756-2.623l.979-45.135a2.706,2.706,0,0,0-2.639-2.756l-65.852-1.428a2.673,2.673,0,0,0-2.739,2.623Z",
    transform: "translate(-322.567 -49.338)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.59,286.3l-.979,45.135a2.706,2.706,0,0,0,2.623,2.756h1.1a2.706,2.706,0,0,0,2.756-2.623l.979-45.135a2.706,2.706,0,0,0-2.639-2.756h-1.1a2.673,2.673,0,0,0-2.739,2.623Z",
    transform: "translate(-296.82 -48.777)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.374,284.265a2.656,2.656,0,0,0-2.573,2.623l-.465,20.933a2.125,2.125,0,0,1-2.175,2.091l-60.49-1.311a2.158,2.158,0,0,1-2.092-2.175l.465-21a2.656,2.656,0,0,1,2.722-2.606l65.869,1.428Z",
    transform: "translate(-322.58 -49.345)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.374,284.265a2.656,2.656,0,0,0-2.573,2.623l-.465,20.933a2.125,2.125,0,0,1-2.175,2.091l-60.49-1.311a2.158,2.158,0,0,1-2.092-2.175l.465-21a2.656,2.656,0,0,1,2.722-2.606l65.869,1.428Z",
    transform: "translate(-322.58 -49.345)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.714,0h4.98a.8.8,0,0,1,.8.8V12.915H0V.8A.8.8,0,0,1,.714,0Z",
    transform: "translate(34.221 270.098) rotate(-178.76)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.971,305.455h0l-5.661-.133a1.616,1.616,0,0,1-1.61-1.677V300.94a1.66,1.66,0,0,1,1.66-1.66l5.661.116a1.673,1.673,0,0,1,1.61,1.693V303.8a1.66,1.66,0,0,1-1.66,1.66Zm-5.611-5.3a.83.83,0,0,0-.813.8v2.706a.747.747,0,0,0,.216.581.78.78,0,0,0,.581.249l5.661.133a.78.78,0,0,0,.83-.8v-2.722a.863.863,0,0,0-.232-.581.88.88,0,0,0-.564-.249l-5.661-.116Z",
    transform: "translate(-311.941 -38.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.561,273.4l-1.411,12.732,13.413-4.681S352.16,270,346.2,270Z",
    transform: "translate(-312.304 -57.805)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.843,287.308l11.271-.581-.531-9.827-13.413,4.681Z",
    transform: "translate(-312.291 -53.251)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.846 212.195)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.561,273.4l-1.411,12.732,13.413-4.681S352.16,270,346.2,270Z",
    transform: "translate(-338.15 -270)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.843,287.308l11.271-.581-.531-9.827-13.413,4.681Z",
    transform: "translate(-338.137 -265.446)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.842,187.73c-4.864,5.744-17.546,53.4-19.306,67.662s6.64,73.355,6.64,73.355l12.732-1.959s-3.984-61.7-2.224-65.769,12.8-47.808,12.8-47.808,1.162-8.433-.564-14.309S353.842,187.73,353.842,187.73Z",
    transform: "translate(-314.849 -112.104)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.842,187.73c-4.864,5.744-17.546,53.4-19.306,67.662s6.64,73.355,6.64,73.355l12.732-1.959s-3.984-61.7-2.224-65.769,12.8-47.808,12.8-47.808,1.162-8.433-.564-14.309S353.842,187.73,353.842,187.73Z",
    transform: "translate(-314.849 -112.104)",
    fill: "#fff",
    opacity: 0.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(261.483 131.891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.53,101.32H285.506L157.52,623.074h308Z",
    transform: "translate(-157.52 -101.32)",
    fill: "#2fc135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.53,101.32H285.506L157.52,623.074h308Z",
    transform: "translate(-157.52 -101.32)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,101.32H280.844L169.79,623.074H437.067Z",
    transform: "translate(-149.422 -101.32)",
    fill: "#fff",
    opacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.509 86.474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.7,97.6H78.7a2.49,2.49,0,1,1,0-4.98h572a2.49,2.49,0,1,1,0,4.98Z",
    transform: "translate(-76.21 -61.644)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.434,
    height: 38.744,
    transform: "translate(253.283 12.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.104,
    height: 9.18,
    transform: "translate(259.757)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,114.624h24.85l-7.935-9.844H231.738Z",
    transform: "translate(25.496 -53.619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.092,77v55.959H248.271l-2.9-5.578H233l-1.843,5.578h-.847V77Z",
    transform: "translate(25.496 -71.954)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.675,
    height: 55.959,
    transform: "translate(274.913 5.046)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.565,86.2c0,4-2.307,7.254-5.129,7.254a3.488,3.488,0,0,1-.714,0c-2.49-.465-4.432-3.5-4.432-7.171s1.942-6.64,4.432-7.171a2.623,2.623,0,0,1,.714,0C240.258,78.944,242.565,82.264,242.565,86.2Z",
    transform: "translate(26.803 -70.577)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1,86.221c0,3.669-1.909,6.64-4.382,7.171-2.49-.465-4.432-3.5-4.432-7.171s1.942-6.64,4.432-7.171C239.2,79.531,241.1,82.553,241.1,86.221Z",
    transform: "translate(26.803 -70.601)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.195,84.644c0,1.76-.847,3.187-1.892,3.187s-1.892-1.428-1.892-3.187.847-3.2,1.892-3.2S237.195,82.884,237.195,84.644Z",
    transform: "translate(27.542 -69.023)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.434,
    height: 38.744,
    transform: "translate(283.179 12.433)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.014,
    height: 37.184,
    transform: "translate(286.599 13.214)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.897,
    height: 30.727,
    transform: "translate(320.978 16.849) rotate(90)",
    fill: "#2fc135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.536,107.566a1.66,1.66,0,0,1-1.394-.78l-7.8-10.939a2.473,2.473,0,0,1,.216-3.054,1.66,1.66,0,0,1,2.573.249l6.408,8.981,10.591-14.84a1.66,1.66,0,0,1,2.59-.249,2.473,2.473,0,0,1,.2,3.071l-11.985,16.783A1.66,1.66,0,0,1,263.536,107.566Z",
    transform: "translate(41.074 -65.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.434,
    height: 38.744,
    transform: "translate(452.599 12.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.104,
    height: 9.18,
    transform: "translate(459.073)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.38,114.624h24.85l-7.918-9.844h-15.5Z",
    transform: "translate(104.742 -53.619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.178,77v55.959H368.341l-2.905-5.578H353.069l-1.843,5.578h-.847V77Z",
    transform: "translate(104.742 -71.954)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.675,
    height: 55.959,
    transform: "translate(474.229 5.046)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.629,86.2c0,4-2.307,7.254-5.129,7.254a3.487,3.487,0,0,1-.714,0c-2.49-.465-4.416-3.5-4.416-7.171s1.926-6.64,4.416-7.171a2.623,2.623,0,0,1,.714,0C360.321,78.944,362.629,82.264,362.629,86.2Z",
    transform: "translate(106.056 -70.577)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.185,86.221c0,3.669-1.926,6.64-4.4,7.171-2.49-.465-4.416-3.5-4.416-7.171s1.926-6.64,4.416-7.171C359.259,79.531,361.185,82.553,361.185,86.221Z",
    transform: "translate(106.056 -70.601)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.275,84.644c0,1.76-.847,3.187-1.892,3.187s-1.892-1.428-1.892-3.187.847-3.2,1.892-3.2S357.275,82.884,357.275,84.644Z",
    transform: "translate(106.795 -69.023)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.434,
    height: 38.744,
    transform: "translate(482.496 12.433)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.014,
    height: 37.184,
    transform: "translate(485.915 13.214)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.897,
    height: 30.727,
    transform: "translate(520.294 16.849) rotate(90)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.542,97.968l7.968-8.649a2.208,2.208,0,0,0,0-2.938,1.809,1.809,0,0,0-2.706,0l-7.968,8.649-7.968-8.649a1.809,1.809,0,0,0-2.706,0,2.208,2.208,0,0,0,0,2.938l7.968,8.649-7.968,8.632a2.208,2.208,0,0,0,0,2.938,1.826,1.826,0,0,0,1.361.614,1.793,1.793,0,0,0,1.345-.614l7.968-8.649,7.968,8.649a1.826,1.826,0,0,0,1.361.614,1.793,1.793,0,0,0,1.345-.614,2.208,2.208,0,0,0,0-2.938Z",
    transform: "translate(120.069 -66.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.434,
    height: 38.744,
    transform: "translate(53.967 12.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.104,
    height: 9.18,
    transform: "translate(60.441)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23,114.624H135.1l-7.935-9.844H111.674Z",
    transform: "translate(-53.757 -53.619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.028,77v55.959H128.191l-2.888-5.578H112.936l-1.843,5.578h-.863V77Z",
    transform: "translate(-53.757 -71.954)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.675,
    height: 55.959,
    transform: "translate(75.596 5.046)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,86.2c0,4-2.307,7.254-5.129,7.254a3.321,3.321,0,0,1-.714,0c-2.507-.465-4.432-3.5-4.432-7.171s1.926-6.64,4.432-7.171a2.556,2.556,0,0,1,.714,0C120.155,78.944,122.5,82.264,122.5,86.2Z",
    transform: "translate(-52.443 -70.578)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.035,86.221c0,3.669-1.909,6.64-4.382,7.171-2.507-.465-4.432-3.5-4.432-7.171s1.926-6.64,4.432-7.171C119.126,79.531,121.035,82.553,121.035,86.221Z",
    transform: "translate(-52.443 -70.601)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.125,84.644c0,1.76-.847,3.187-1.892,3.187s-1.892-1.428-1.892-3.187.847-3.2,1.892-3.2S117.125,82.884,117.125,84.644Z",
    transform: "translate(-51.704 -69.023)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.434,
    height: 38.744,
    transform: "translate(83.863 12.433)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.014,
    height: 37.184,
    transform: "translate(87.283 13.214)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.897,
    height: 30.727,
    transform: "translate(121.645 16.849) rotate(90)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.412,97.968l7.968-8.649a2.208,2.208,0,0,0,0-2.938,1.809,1.809,0,0,0-2.706,0l-7.968,8.649-7.968-8.649a1.809,1.809,0,0,0-2.706,0,2.208,2.208,0,0,0,0,2.938L142,97.968l-7.968,8.632a2.208,2.208,0,0,0,0,2.938,1.793,1.793,0,0,0,2.706,0l7.968-8.649,7.968,8.649a1.793,1.793,0,0,0,1.345.614,1.826,1.826,0,0,0,1.361-.614,2.208,2.208,0,0,0,0-2.938Z",
    transform: "translate(-38.417 -66.163)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.541 248.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.37,406.792l1.295,1.809,2.59-1.112,1.66,7.918,10.906,15.123s4.167.664.88-7.935a6.635,6.635,0,0,1-.332-1.295c-.979-5.146,1.162-14.94,1.162-14.94l-5.993-8.3a14.691,14.691,0,0,0-1.66.183C238.338,398.591,233.375,399.787,230.37,406.792Z",
    transform: "translate(-205.497 -22.223)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.37,406.792l1.295,1.809,2.59-1.112,1.66,7.918,10.906,15.123s4.167.664.88-7.935a6.635,6.635,0,0,1-.332-1.295c-.979-5.146,1.162-14.94,1.162-14.94l-5.993-8.3a14.691,14.691,0,0,0-1.66.183C238.338,398.591,233.375,399.787,230.37,406.792Z",
    transform: "translate(-205.497 -22.223)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.66,398.288h0c2.009.216.249,9.08,1.062,14.044.714,4.449,2.656,8.632,5.478,9.064-.979-5.146,2.523-16.866,2.523-16.866l-4.814-6.64S237.722,398.073,236.66,398.288Z",
    transform: "translate(-201.346 -22.335)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.66,398.288h0c2.009.216.249,9.08,1.062,14.044.714,4.449,2.656,8.632,5.478,9.064-.979-5.146,2.523-16.866,2.523-16.866l-4.814-6.64S237.722,398.073,236.66,398.288Z",
    transform: "translate(-201.346 -22.335)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.373,423.24H243.6l.614-2.739,7.37,3.32h18.642s2.971-2.988-5.91-5.362a6.3,6.3,0,0,1-1.262-.481c-4.731-2.224-11.471-9.728-11.471-9.728H241.339a12.311,12.311,0,0,0-.847,1.477C239.381,411.985,237.455,416.716,241.373,423.24Z",
    transform: "translate(-199.784 -15.497)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.91,410.612h0c1.361-1.511,7.5,5.113,12.018,7.37,4.017,1.992,8.532,2.888,10.541.847-4.731-2.224-12.184-11.919-12.184-11.919h-8.3S240.391,409.649,239.91,410.612Z",
    transform: "translate(-199.201 -16.382)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.979,212.4,286.53,200.65l13.894,1.179s3.32,10.724-2.274,12.2Z",
    transform: "translate(-168.432 -152.513)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.831,193.29l11.587,5.063v8.333l-13.878-1.179Z",
    transform: "translate(-168.425 -157.371)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.68,208.6s-.6,52.356-12.218,52.356c-6.457,0-13.761-4.2-19.92-8.947a110.727,110.727,0,0,1-14.475-13.5v-.183L264,214.031c11.438-.282,31.407,25.929,31.407,25.929l9.628-33.2Z",
    transform: "translate(-183.301 -148.481)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,242.738a110.727,110.727,0,0,1-14.475-13.5v-.183l3.718-8.3A33.416,33.416,0,0,1,280.9,242.738Z",
    transform: "translate(-181.704 -139.241)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.647,179.135s3.635-6.275,14.044-7.354,24.219,4.5,26.328,20.368,6.64,24.6,6.64,24.6-33.532,8.765-42.961,5.611S219.694,183.7,239.647,179.135Z",
    transform: "translate(-205.96 -171.652)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.391,400.711c-4.98,9.213-10.043,19.123-14.94,29.05-6.391,13.1-12.4,26.228-17.546,37.981-5.428,12.384-9.827,23.24-12.583,30.727-2.606.3-10.458-4.382-12.732-8.632a424.312,424.312,0,0,1,18.26-71.081c5.08-13.878,11.3-27.539,18.775-38.578-30.544-86.884-23.057-119.52-23.057-119.52l35.391-1.577s5.345,32.353,9.628,65.537h0c2.241,17.4,4.167,35.026,4.88,48.339v.133a51.808,51.808,0,0,1-6.076,27.622Z",
    transform: "translate(-199.412 -113.95)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.8,339.864c-4.482-14.774-7.719-27.556-9.96-38.529,2.274-8.566,5.478-15.919,9.844-20.335C260.651,281,266.942,304.9,260.8,339.864Z",
    transform: "translate(-191.987 -99.483)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.935,404.257c-5.428,12.383-9.827,23.24-12.583,30.727-2.606.3-10.458-4.382-12.732-8.632a424.3,424.3,0,0,1,18.26-71.081C260.519,369.662,263.491,387.839,264.935,404.257Z",
    transform: "translate(-199.392 -50.464)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.512,256.75s-10.292,79.68-16.2,118.076c-6.208,40.288-6.989,104.912-5.445,131.256-2.258,1.311-10.475,2.9-14.94,1.511,0,0-21-81.473-7.055-128.8-12.7-93.209,5.694-116.034,5.694-116.034Z",
    transform: "translate(-204.362 -115.488)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.779,236.492A166.847,166.847,0,0,0,238.6,212.671c1.129-.133,2.291-.249,3.436-.349a167.151,167.151,0,0,1,23.605-.8c1.942.116,3.951.282,5.926.448h0C276.448,223.162,272.779,236.492,272.779,236.492Z",
    transform: "translate(-200.065 -145.411)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.014,286.674c-1.062-12.085-5.395-34.246-12.848-57.519-2.424-7.57,1.66-16.119,1.66-16.119s10.159-.249,11.172-.365,2.291-.249,3.436-.349a167.152,167.152,0,0,1,23.605-.8c1.942.116,3.951.282,5.926.448.631,0,7.769.133,8.383.2,0,0,9.877,11.288,10.475,20.435a158.551,158.551,0,0,1,.813,21.182c0,8.3-.647,19.256-1.2,30.926Z",
    transform: "translate(-205.479 -145.411)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.014,286.674c-1.062-12.085-5.395-34.246-12.848-57.519-2.424-7.57,1.66-16.119,1.66-16.119s10.159-.249,11.172-.365,2.291-.249,3.436-.349a167.152,167.152,0,0,1,23.605-.8c1.942.116,3.951.282,5.926.448.631,0,7.769.133,8.383.2,0,0,9.877,11.288,10.475,20.435a158.551,158.551,0,0,1,.813,21.182c0,8.3-.647,19.256-1.2,30.926Z",
    transform: "translate(-205.479 -145.411)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.564,258.129l51.46-3.469s1.544,15.471,1.2,15.255-55.079,1.909-55.079,1.909Z",
    transform: "translate(-201.029 -116.867)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.065,258.392l50.979-2.822V260.4L238.6,263.14Z",
    transform: "translate(-200.065 -116.266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.812,262.075a1.378,1.378,0,0,1-1.394-1.278l-.216-2.839a1.344,1.344,0,0,1,.332-1.013,1.378,1.378,0,0,1,.946-.481l5.578-.432a1.378,1.378,0,0,1,1.062.365,1.411,1.411,0,0,1,.448,1.029V260.4a1.394,1.394,0,0,1-1.328,1.394l-5.362.282Zm-.564-1.345a.531.531,0,0,0,.6.515l5.362-.282a.564.564,0,0,0,.531-.564v-2.971a.548.548,0,0,0-.183-.415.581.581,0,0,0-.432-.149l-5.578.432a.548.548,0,0,0-.382.2.515.515,0,0,0-.133.4Z",
    transform: "translate(-189.112 -115.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.27,322.244l-17.8-3.22,10.358-38.3s-2.639-9.512-5.578-20.418c-1.411-5.3-2.888-10.923-4.15-15.936a131.859,131.859,0,0,1-3.32-15.172c-.332-6.109,5.113-15.986,5.113-15.986l12.848-2.075s11.72,12.931,12.483,37.715S249.27,322.244,249.27,322.244Z",
    transform: "translate(-206.552 -145.59)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.3,211.147s11.172,19.455,13.745,33.831,9.661,75.5,9.661,75.5l3.851-1.926-5.362-36.52s1.926-42.3.432-50.979-11.222-19.92-11.222-19.92Z",
    transform: "translate(-187.723 -145.597)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,210.851l.764-.681s10.856,1.378,20.816,13.811l-3.868,3.768,6.64,5.312-3.137,25.647s-10.06-34.179-14.409-42.38A30.544,30.544,0,0,0,254,210.851Z",
    transform: "translate(-189.901 -146.23)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,210.831l.764-.631s10.856,1.328,20.816,13.761l-3.868,3.768,6.64,5.312-3.137,25.647s-10.06-34.179-14.409-42.38A30.544,30.544,0,0,0,254,210.831Z",
    transform: "translate(-189.901 -146.211)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.47,212s12.433,13.728,9.661,49.8L241.963,235.87l4.4-7.072-10.292-9.661s5.395-10.242,9.213-9.23Z",
    transform: "translate(-201.735 -146.45)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.47,212s12.433,13.728,9.661,49.8L241.963,235.87l4.4-7.072-10.292-9.661s5.395-10.242,9.213-9.23Z",
    transform: "translate(-201.735 -146.45)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.016,225.073l-2.855,17.081L241.684,222.5c4.748-5.246,1.76-19.057-.564-26.56l6.374,4.764,9.462,7.088a17.448,17.448,0,0,0,.465,5.827c.714,3,1.992,5.843,3.42,6.441Z",
    transform: "translate(-198.402 -155.622)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.889,211.7c-3.785-.847-8.732-4.764-9.528-8.615a18.728,18.728,0,0,1-.4-4.3l9.462,7.088a17.448,17.448,0,0,0,.465,5.827Z",
    transform: "translate(-195.87 -153.741)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.886,209.34s9.611,7.42,20.9,23.091c0,0,1.013-15.637-2.855-21.248l.8-.963a37.549,37.549,0,0,1,14.94,11.8l-7.437-2.357-5.1,13.778L249.8,220.777,239.47,222.57S239.918,212.394,243.886,209.34Z",
    transform: "translate(-199.491 -146.778)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.886,209.34s9.611,7.42,20.9,23.091c0,0,1.013-15.637-2.855-21.248l.8-.963a37.549,37.549,0,0,1,14.94,11.8l-7.437-2.357-5.1,13.778L249.8,220.777,239.47,222.57S239.918,212.394,243.886,209.34Z",
    transform: "translate(-199.491 -146.778)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.1,194.8c2.722,12.168,3.6,17.38,10.807,23.024,10.823,8.483,25.132,3.32,26.079-9.246.863-11.288-3.735-29.316-16.5-32.934A16,16,0,0,0,237.1,194.8Z",
    transform: "translate(-201.374 -169.52)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,188.546c.183,1.046.88,1.826,1.527,1.743s1.062-.963.88-1.992-.88-1.809-1.544-1.66S246.216,187.517,246.4,188.546Z",
    transform: "translate(-194.949 -161.774)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.153,187.537c.183,1.029.863,1.809,1.527,1.66s1.046-.963.863-1.992-.863-1.809-1.527-1.743S253.937,186.491,254.153,187.537Z",
    transform: "translate(-189.838 -162.541)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.48,185.933l2.307-.963S255.874,187.028,254.48,185.933Z",
    transform: "translate(-189.585 -162.862)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,188.33a30.776,30.776,0,0,0,4.781,6.192,4.117,4.117,0,0,1-3.486,1.079Z",
    transform: "translate(-191.221 -160.645)",
    fill: "#d58745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.8,185.228a.531.531,0,0,0,.415-.2,4.482,4.482,0,0,1,3.918-1.66.564.564,0,0,0,.664-.5.664.664,0,0,0-.548-.7,5.611,5.611,0,0,0-4.98,2.042.6.6,0,0,0,.1.847A.647.647,0,0,0,244.8,185.228Z",
    transform: "translate(-196.409 -164.731)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.643,183.649a.581.581,0,0,0,.432-.133.6.6,0,0,0,0-.847,6.408,6.408,0,0,0-5.113-2.49.548.548,0,0,0-.5.647.647.647,0,0,0,.681.564,5.129,5.129,0,0,1,4.017,2.025.7.7,0,0,0,.481.232Z",
    transform: "translate(-190.262 -166.024)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,187.019l2.307-.979S248.141,188.115,246.73,187.019Z",
    transform: "translate(-194.7 -162.156)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.419,202.667s5.993-8.732,1.428-21.58c0,0,13.546-6.64,23.8,3.453,0,0-9.545-16.733-29.482-8.715s-4.98,27.158-2.424,28.751S246.419,202.667,246.419,202.667Z",
    transform: "translate(-204.448 -170.334)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.93,196.317a9.96,9.96,0,0,0,6.64,3.884c3.32.4,4.349-3,2.805-6.125-1.378-2.822-4.8-6.408-7.9-5.362S233.888,193.644,235.93,196.317Z",
    transform: "translate(-202.641 -160.514)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.971,195.423a34.1,34.1,0,0,0-1.66,4.814,8.193,8.193,0,0,1-.9,0c-4.05-.4-5.777-1.926-6.491-3.5a5.329,5.329,0,0,1-.4-2.44,5.147,5.147,0,0,1,.266-1.394,19.057,19.057,0,0,0,7.769,2.44C256.44,195.39,256.971,195.423,256.971,195.423Z",
    transform: "translate(-194.184 -157.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.574,195.29l-.515,1.411c-3.818-.4-6.441-1.179-7.52-2.457a5.144,5.144,0,0,1,.266-1.394A19.057,19.057,0,0,0,255.574,195.29Z",
    transform: "translate(-194.165 -157.661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.271,198.663c-4.05-.4-5.777-1.926-6.491-3.5a13.281,13.281,0,0,1,4.4,1.345A4.88,4.88,0,0,1,254.271,198.663Z",
    transform: "translate(-194.007 -156.137)",
    fill: "#de5753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.287,247.072a5.91,5.91,0,0,1-2.357,2.938c-1.411-5.3-2.888-10.923-4.15-15.936,3.32-3.984,6.076-7.3,6.076-7.3S240.64,238.523,237.287,247.072Z",
    transform: "translate(-205.227 -135.274)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.766,212.39c-7.055.863-28.618,54.431-27.324,62.9s47.675,4.615,47.675,4.615V267l-27.075-5.461,9.362-18.393a46.63,46.63,0,0,0,2.042-16.467A37.2,37.2,0,0,0,242.766,212.39Z",
    transform: "translate(-215.386 -144.765)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.1,286.762l-35.59-4.316a2.374,2.374,0,0,1-2.108-2.722l6.258-45.766a2.556,2.556,0,0,1,2.855-2.108l35.59,4.316a2.357,2.357,0,0,1,2.108,2.706l-6.258,45.783A2.556,2.556,0,0,1,264.1,286.762Z",
    transform: "translate(-208.135 -131.937)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.1,286.762l-35.59-4.316a2.374,2.374,0,0,1-2.108-2.722l6.258-45.766a2.556,2.556,0,0,1,2.855-2.108l35.59,4.316a2.357,2.357,0,0,1,2.108,2.706l-6.258,45.783A2.556,2.556,0,0,1,264.1,286.762Z",
    transform: "translate(-208.135 -131.937)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.622,286.579l-34.113-4.133a2.374,2.374,0,0,1-2.108-2.722l6.258-45.766a2.556,2.556,0,0,1,2.855-2.108l34.113,4.133a2.357,2.357,0,0,1,2.092,2.722l-6.242,45.766a2.59,2.59,0,0,1-2.855,2.108Z",
    transform: "translate(-208.135 -131.937)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.777,246.013a3.967,3.967,0,0,0-4.432,3.32,3.7,3.7,0,0,0,3.32,4.216,4,4,0,0,0,4.416-3.32,3.669,3.669,0,0,1-3.3-4.216Z",
    transform: "translate(-200.919 -122.596)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.685,238.438l-18.708-2.274a2.191,2.191,0,0,1-1.876-1.66l-.581-2.374,24.9,3.021-1.278,2.141a2.374,2.374,0,0,1-2.457,1.145Z",
    transform: "translate(-202.758 -131.737)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.215,244.385l-10.591,3.038-2.224,7.005c1.013,5.71,11.969,3.32,11.969,3.32l2.258,1.411a3.038,3.038,0,0,0,4.6-2.042l1.162-6.64a3.021,3.021,0,0,0-1.129-2.922l-3.32-2.606a3.021,3.021,0,0,0-2.722-.564Z",
    transform: "translate(-197.557 -123.723)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.186,237c-3.718,10.176-6.208,19.073-5.744,22.128,1.278,8.466,47.675,4.615,47.675,4.615v-12.9L236.043,245.3Z",
    transform: "translate(-215.386 -128.523)",
    fill: "#c12f33"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.194 219.041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.743,153.82H270.375a7.005,7.005,0,0,0-7.005,7.005v19.854a6.989,6.989,0,0,0,7.005,6.989h4.8l-1.179,7.4,5.876-7.4h10.873a6.989,6.989,0,0,0,6.989-6.989v-19.92a7.005,7.005,0,0,0-6.989-6.939Z",
    transform: "translate(-263.37 -153.82)",
    fill: "#2fc135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.768,162.368c1.776-2.955,5.229-1.876,7.055.382,1.743-2.307,5.179-3.469,7.022-.564,3.1,4.9-3.1,9.562-6.042,11.388l-.847.531-.847-.5C273.121,171.847,266.8,167.348,269.768,162.368Z",
    transform: "translate(-259.659 -149.437)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.71 232.045)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.635,208.3c10.408,9.678,11.62,43.16,12.483,57.386.515,8.3,1.793,17.181,2.955,25.614,1.228,8.7,2.44,17.48,3.586,26.228a4.366,4.366,0,0,1-8.449,2.058c-3-8.466-5.677-16.982-8-25.647a206.27,206.27,0,0,1-6.64-33.383c-1.776-12.267-3.32-25.249-6.972-36.985a21.448,21.448,0,0,0-1.1-2.54c.116,0,.2.232.365.315-8.4-8,2.872-20.567,11.753-13.048Z",
    transform: "translate(-45.97 -132.393)",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.635,208.3c10.408,9.678,11.62,43.16,12.483,57.386.515,8.3,1.793,17.181,2.955,25.614,1.228,8.7,2.44,17.48,3.586,26.228a4.366,4.366,0,0,1-8.449,2.058c-3-8.466-5.677-16.982-8-25.647a206.27,206.27,0,0,1-6.64-33.383c-1.776-12.267-3.32-25.249-6.972-36.985a21.448,21.448,0,0,0-1.1-2.54c.116,0,.2.232.365.315-8.4-8,2.872-20.567,11.753-13.048Z",
    transform: "translate(-45.97 -132.393)",
    fill: "#fff",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.947,272.921l6.242,10.906-13.894,1.029s-4.98-10.06.315-12.417Z",
    transform: "translate(-35.897 -88.535)",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160,291.733l-12.234-3.171-1.311-8.234,13.894-1.029Z",
    transform: "translate(-35.053 -84.008)",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.788,223.416c-8.831,7.321-19.688,15.521-25.564,24.9,0-.614-.2-.78-.133-.481,1.876,4.648,5.777,8.549,9.2,12.516,4.665,5.113,9.728,10.259,14.724,15.272a4.4,4.4,0,0,1-5.3,6.889,122.456,122.456,0,0,1-27.075-20.318c-4.98-5.08-9.18-12.035-6.424-19.405,2.49-7.337,7.8-13.18,12.832-18.476a145.152,145.152,0,0,1,17.181-14.94c9.5-6.64,19.538,6.789,10.558,14.06Z",
    transform: "translate(-79.343 -131.342)",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.788,223.416c-8.831,7.321-19.688,15.521-25.564,24.9,0-.614-.2-.78-.133-.481,1.876,4.648,5.777,8.549,9.2,12.516,4.665,5.113,9.728,10.259,14.724,15.272a4.4,4.4,0,0,1-5.3,6.889,122.456,122.456,0,0,1-27.075-20.318c-4.98-5.08-9.18-12.035-6.424-19.405,2.49-7.337,7.8-13.18,12.832-18.476a145.152,145.152,0,0,1,17.181-14.94c9.5-6.64,19.538,6.789,10.558,14.06Z",
    transform: "translate(-79.343 -131.342)",
    fill: "#fff",
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.92,256.082s.764,13,7.121,35.773a360.9,360.9,0,0,0,14.475,41.417c3.171,7.619,6.806,15.7,10.973,24.219,1.876,3.868,3.884,7.8,5.993,11.852,2.44,68.956,41.135,139.075,41.135,139.075,2.141,1.112,9.628-.1,9.578-2.274-5.727-9.113-17.015-97.475-24.286-139.44-.448-5.694-1.1-11.8-1.909-18.111-2.125-16.915-5.262-35.325-8.3-51.46-4.8-25.481-9.379-45.484-9.379-45.484L143.556,252.9Z",
    transform: "translate(-58.502 -102.257)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.92,256.082s.764,13,7.121,35.773a360.9,360.9,0,0,0,14.475,41.417c3.171,7.619,6.806,15.7,10.973,24.219,1.876,3.868,3.884,7.8,5.993,11.852,2.44,68.956,41.135,139.075,41.135,139.075,2.141,1.112,9.628-.1,9.578-2.274-5.727-9.113-17.015-97.475-24.286-139.44-.448-5.694-1.1-11.8-1.909-18.111-2.125-16.915-5.262-35.325-8.3-51.46-4.8-25.481-9.379-45.484-9.379-45.484L143.556,252.9Z",
    transform: "translate(-58.502 -102.257)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.027,352.968h0c1.029,7.42,2.341,15.338,3.984,23.8C93.183,422.9,121.6,512.892,121.6,512.892c4.814.946,9.08.315,11.238-1.295-5.362-27.124-1.511-97.641,2.656-139.789.365-3.818.83-8.034,1.345-12.516.863-7.6,1.876-15.986,2.971-24.634,1.826-14.492,3.9-29.747,5.76-43.26,2.274-16.351,4.266-30.179,5.262-37.118.448-3.054.7-4.781.7-4.781l-39.923,4.316s-10.143,11.388-11.62,46.928a290.5,290.5,0,0,0,3.038,52.224Z",
    transform: "translate(-65.815 -103.675)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.027,352.968h0c1.029,7.42,2.341,15.338,3.984,23.8C93.183,422.9,121.6,512.892,121.6,512.892c4.814.946,9.08.315,11.238-1.295-5.362-27.124-1.511-97.641,2.656-139.789.365-3.818.83-8.034,1.345-12.516.863-7.6,1.876-15.986,2.971-24.634,1.826-14.492,3.9-29.747,5.76-43.26,2.274-16.351,4.266-30.179,5.262-37.118.448-3.054.7-4.781.7-4.781l-39.923,4.316s-10.143,11.388-11.62,46.928a290.5,290.5,0,0,0,3.038,52.224Z",
    transform: "translate(-65.815 -103.675)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.572,203.2c12.732,4.25,13.629,13.28,20.916,32.353A28.037,28.037,0,0,1,138.6,247.688S120.378,213.708,138.572,203.2Z",
    transform: "translate(-45.584 -134.233)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.53,235.543a28.319,28.319,0,0,1-15.123,11.089,22.56,22.56,0,0,1-5.76,1.079l-.282-.564c-1.444-2.855-7.885-16.168-7.835-27.888,0-6.524,2.058-12.583,8.084-16.069C151.23,207.44,152.177,216.553,159.53,235.543Z",
    transform: "translate(-45.56 -134.24)",
    fill: "#fff",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M149.26,232.876a28.584,28.584,0,0,1-8.034,3.918,62.648,62.648,0,0,1-5.976-18.642,9.844,9.844,0,0,1,9.628,4.98A36.8,36.8,0,0,1,149.26,232.876Z",
    transform: "translate(-42.445 -124.402)",
    opacity: 0.1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M150.284,172s11.836,29.6,0,55.361-45.052,10.292-48.339,4.117,4.4-18.758,4.4-30.278-2.789-17.8-.7-27.257S150.284,172,150.284,172Z",
    transform: "translate(-64.965 -156.698)",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.043,336.277h0a124.354,124.354,0,0,0,33.814,6.358c.863-7.6,1.876-15.986,2.971-24.634,3.171,7.619,6.806,15.7,10.973,24.219a83.214,83.214,0,0,0,30.511-8.848c-2.125-16.915-5.262-35.325-8.3-51.46a49.6,49.6,0,0,0-13.562-5.461,59.138,59.138,0,0,0-13.844-1.66,104.009,104.009,0,0,0-20.235,1.843,127.332,127.332,0,0,0-25.415,7.5,290.5,290.5,0,0,0,3.088,52.141Z",
    transform: "translate(-65.831 -86.985)",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.62,206.351a252.112,252.112,0,0,1,5.163,26.676c.714,4.98,1.411,10.574,1.975,16.6a313.508,313.508,0,0,1,1.328,36.869h52.572s8.3-61.42-5.412-81.34C157.247,205.206,130.3,192.507,101.62,206.351Z",
    transform: "translate(-64.64 -136.422)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.62,206.351a252.112,252.112,0,0,1,5.163,26.676c.714,4.98,1.411,10.574,1.975,16.6a313.508,313.508,0,0,1,1.328,36.869h52.572s8.3-61.42-5.412-81.34C157.247,205.206,130.3,192.507,101.62,206.351Z",
    transform: "translate(-64.64 -136.422)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.73,224.523c.714,4.98,1.411,10.574,1.975,16.6A41,41,0,0,0,108.2,212.77Z",
    transform: "translate(-62.588 -127.917)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.379,197.71c-16.484,0-18.559,13.562-18.559,13.562l7.7-3.32,22.659,15.139,5.561-15.289,6.989,1.295S139.7,197.727,125.379,197.71Z",
    transform: "translate(-61.208 -137.857)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.379,197.71c-16.484,0-18.559,13.562-18.559,13.562l7.7-3.32,22.659,15.139,5.561-15.289,6.989,1.295S139.7,197.727,125.379,197.71Z",
    transform: "translate(-61.208 -137.857)",
    fill: "#fff",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.108,230.867,111.86,212.375c5.163-5.3,2.523-19.92.365-27.8l16.119,12.948c-1.079,6.175-.813,12.749,8.2,14.857C136.544,212.375,133.091,230.818,133.108,230.867Z",
    transform: "translate(-57.882 -146.529)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.108,230.867,111.86,212.375c5.163-5.3,2.523-19.92.365-27.8l16.119,12.948c-1.079,6.175-.813,12.749,8.2,14.857C136.544,212.375,133.091,230.818,133.108,230.867Z",
    transform: "translate(-57.882 -146.529)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116.049,187.76l9.545,7.653a24.65,24.65,0,0,0-.432,4.382c-3.42-.5-8.3-4.216-8.964-7.752a12.052,12.052,0,0,1-.149-4.283Z",
    transform: "translate(-55.199 -144.424)",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.151,183.053c2.407,12.832,3.154,18.26,10.475,24.452,11.006,9.246,26.128,4.349,27.573-8.732,1.311-11.769-2.855-30.76-16.069-34.993a16.716,16.716,0,0,0-21.978,19.273Z",
    transform: "translate(-60.58 -160.898)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.151,183.053c2.407,12.832,3.154,18.26,10.475,24.452,11.006,9.246,26.128,4.349,27.573-8.732,1.311-11.769-2.855-30.76-16.069-34.993a16.716,16.716,0,0,0-21.978,19.273Z",
    transform: "translate(-60.58 -160.898)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.961,172.527c-7.072,9.13,7.47,19.638-7.072,19.024s-8.632-21.132,0-25.8S120.961,172.527,120.961,172.527Z",
    transform: "translate(-62.368 -159.685)",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.253,177.079c.149,1.079.847,1.926,1.544,1.876s1.129-.979.963-2.058-.847-1.926-1.527-1.876S120.087,175.984,120.253,177.079Z",
    transform: "translate(-52.365 -152.833)",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128.15,176.609c.149,1.1.847,1.926,1.544,1.876s1.129-.979.979-2.058-.847-1.926-1.544-1.876S127.934,175.53,128.15,176.609Z",
    transform: "translate(-47.164 -153.143)",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.54,175l2.424-1S129.968,176.191,128.54,175Z",
    transform: "translate(-46.873 -153.505)",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.09,177a32.238,32.238,0,0,0,4.781,6.64,4.366,4.366,0,0,1-3.685,1.013Z",
    transform: "translate(-48.49 -151.525)",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.863,185.743a9.32,9.32,0,0,0,1.809,0,.3.3,0,0,0,.266-.349.332.332,0,0,0-.349-.282,9.163,9.163,0,0,1-7.354-2.855.317.317,0,1,0-.448.448A9.645,9.645,0,0,0,125.863,185.743Z",
    transform: "translate(-52.712 -148.117)",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.536,185.524a8.964,8.964,0,0,0,5.445,4.781c2.988.8,4.283-2.623,3.32-6.042-.9-3.088-3.519-7.2-6.441-6.457S106.025,182.52,107.536,185.524Z",
    transform: "translate(-61.211 -151.053)",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M118.276,174a.531.531,0,0,0,.448-.183,4.681,4.681,0,0,1,4.15-1.66.6.6,0,0,0,.714-.5.714.714,0,0,0-.548-.764,5.893,5.893,0,0,0-5.279,1.959.647.647,0,0,0,0,.9.564.564,0,0,0,.515.249Z",
    transform: "translate(-54.106 -155.595)",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.085,173.376a.608.608,0,0,0,.448-1.046,6.64,6.64,0,0,0-5.428-2.407.564.564,0,0,0-.5.7.681.681,0,0,0,.73.564,5.362,5.362,0,0,1,4.283,1.959A.7.7,0,0,0,132.085,173.376Z",
    transform: "translate(-48.16 -156.201)",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.65,175.446l2.44-.946S122.078,176.641,120.65,175.446Z",
    transform: "translate(-52.081 -153.175)",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.056,168.055s-3.868,17.2-16.6,19.123-9.678-16.749,7.188-23.622,30.544,6.806,31.324,10.491a6.291,6.291,0,0,1-2.606,6.009S141.286,168.387,128.056,168.055Z",
    transform: "translate(-63.321 -161.654)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.536,185.524a8.964,8.964,0,0,0,5.445,4.781c2.988.8,4.283-2.623,3.32-6.042-.9-3.088-3.519-7.2-6.441-6.457S106.025,182.52,107.536,185.524Z",
    transform: "translate(-61.211 -151.053)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M113.292,421.24h2.224l.614-2.739,7.37,3.32h18.658s2.955-2.988-5.926-5.362a8.077,8.077,0,0,1-1.262-.481c-4.731-2.224-11.471-9.728-11.471-9.728H113.259a14.293,14.293,0,0,0-.83,1.477C111.3,409.985,109.374,414.716,113.292,421.24Z",
    transform: "translate(-58.484 -0.22)",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M111.84,408.612h0c1.345-1.511,7.5,5.113,12,7.37,4.017,1.992,8.549,2.888,10.541.847C129.652,414.6,122.2,404.91,122.2,404.91h-8.3S112.321,407.649,111.84,408.612Z",
    transform: "translate(-57.895 -1.105)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.84,408.612h0c1.345-1.511,7.5,5.113,12,7.37,4.017,1.992,8.549,2.888,10.541.847C129.652,414.6,122.2,404.91,122.2,404.91h-8.3S112.321,407.649,111.84,408.612Z",
    transform: "translate(-57.895 -1.105)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M160.108,421.24h2.224l.614-2.739,7.37,3.32h18.642s2.971-2.988-5.91-5.362a7.5,7.5,0,0,1-1.262-.481c-4.731-2.224-11.471-9.728-11.471-9.728H160.075a12.312,12.312,0,0,0-.847,1.477C158.149,409.985,156.191,414.716,160.108,421.24Z",
    transform: "translate(-27.579 -0.22)",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M158.65,408.612h0c1.361-1.511,7.5,5.113,12.018,7.37,4.017,1.992,8.532,2.888,10.541.847-4.731-2.224-12.184-11.919-12.184-11.919h-8.3S159.131,407.649,158.65,408.612Z",
    transform: "translate(-27.001 -1.105)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.65,408.612h0c1.361-1.511,7.5,5.113,12.018,7.37,4.017,1.992,8.532,2.888,10.541.847-4.731-2.224-12.184-11.919-12.184-11.919h-8.3S159.131,407.649,158.65,408.612Z",
    transform: "translate(-27.001 -1.105)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M165.255,249.52h-53l-1.428,6.823S91.368,283.3,101.229,350.5c0,0,42.645,4.98,82.784-3.7,0,0-9.014-69.023-18.426-91.549Z",
    transform: "translate(-66.739 -103.662)",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M123.349,255.08H105.57l1.079-5.08h16.7Z",
    transform: "translate(-62.033 -103.345)",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M135.74,250h5.329l.465,5.08H135.74Z",
    transform: "translate(-42.121 -103.345)",
    fill: "#263238"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.801,
    height: 5.063,
    transform: "translate(63.042 146.655)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.349,255.08H105.57l1.079-5.08h16.7Z",
    transform: "translate(-62.033 -103.345)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.74,250h5.329l.465,5.08H135.74Z",
    transform: "translate(-42.121 -103.345)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.801,
    height: 5.063,
    transform: "translate(63.042 146.655)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.728,
    height: 5.843,
    rx: 0.56,
    transform: "translate(84.705 152.116) rotate(180)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114.516,203.06C108.192,203.392,96.7,214.3,87.06,226.7a145.083,145.083,0,0,0,16.5,16.749l18.26-12.915S123.978,210.181,114.516,203.06Z",
    transform: "translate(-74.25 -134.326)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.516,203.06C108.192,203.392,96.7,214.3,87.06,226.7a145.083,145.083,0,0,0,16.5,16.749l18.26-12.915S123.978,210.181,114.516,203.06Z",
    transform: "translate(-74.25 -134.326)",
    fill: "#fff",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.84,216.169a1.046,1.046,0,1,0,1.046-1.029,1.046,1.046,0,0,0-1.046,1.029Z",
    transform: "translate(-49.315 -126.353)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.029,
    cy: 1.029,
    r: 1.029,
    transform: "translate(77.6 103.993)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.029,
    cy: 1.029,
    r: 1.029,
    transform: "translate(78.812 119.862)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.029,
    cy: 1.029,
    r: 1.029,
    transform: "translate(78.812 136.728)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M118.212,260.265l-.681-4a4.731,4.731,0,0,0-2.606-3.453l-6.424-3.1a8.815,8.815,0,0,0-8.068.216l-1.544.863c.681,6.64,6.358,13.446,6.358,13.446l1.411,2.108a3.918,3.918,0,0,0,5.445,1.212l4.216-2.739A4.515,4.515,0,0,0,118.212,260.265Z",
    transform: "translate(-66.442 -104.115)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.212,260.265l-.681-4a4.731,4.731,0,0,0-2.606-3.453l-6.424-3.1a8.815,8.815,0,0,0-8.068.216l-1.544.863c.681,6.64,6.358,13.446,6.358,13.446l1.411,2.108a3.918,3.918,0,0,0,5.445,1.212l4.216-2.739A4.515,4.515,0,0,0,118.212,260.265Z",
    transform: "translate(-66.442 -104.115)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.275 183.905)",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M154.947,272.921l6.242,10.906-13.894,1.029s-4.98-10.06.315-12.417Z",
    transform: "translate(-145.171 -272.44)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M160,291.733l-12.234-3.171-1.311-8.234,13.894-1.029Z",
    transform: "translate(-144.327 -267.912)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindjobs);
export default __webpack_public_path__ + "static/media/Findjobs.21c3b49b4d2960964b5d2084c01054d3.svg";
export { ForwardRef as ReactComponent };